import fetchAx from "@/axios.js";
import moment from "moment";
import { discAx } from "@/axiosInstance.js";

export default {
  namespaced: true,
  state: {
    asamaList: [],
    asamaUser: null,
    workList: [],
    project: [],
    customerList: [],
    systemList: [],
    workType: [],
    erpUserList: [],
    statuList: [],
    platformList: [],
    rowPlatformList: [],
    rowStageList: [],
    projectNameList: [],
    projectRows: [],
    dokumanlar: {},
    fileUrl: [],
    allProject: [],
    asamaEvrakNo: [],
    asamaMusteriAdi: [],
    asamaProjeAdi: [],
    asamaTanimi: "",
    asamaDurumu: [],
    asamaAtananKisi: [],
    asamaTahminSure: [],
    asamaAtamaTarihi: "",
    EVRAKNO: [],
    MUSTERIKODU_AD: [],
    PROJE_ADI: [],
    PROJE_SORUMLUSU: [],
    TALEP_EDEN_KISI: [],
    PROJE_DURUMU: [],
    TARIH: "",
    PROJE_ACIKLAMASI: "",
    listType: "A",
    selectedStatu: ["PLANLANDI", "BASLADI", "TEST EDILIYOR"],
    selectedAsamaStatu: ["PLANLANDI", "BASLADI", "TEST EDILIYOR", ""],
    adminStatuList: [],
    filteredAsamaList: [],
    workAddStatus: false,
    asamaListDoc: [],
    faturalar: [],
    discordId: null,
    calisilanSaat: 0,
  },
  mutations: {
    setCalisilanSaat(state, payload) {
      state.calisilanSaat = payload;
    },
    setDiscordId(state, payload) {
      state.discordId = payload;
    },
    setFaturalar(state, payload) {
      state.faturalar = payload;
    },
    setWorkAddStatus(state, payload) {
      state.workAddStatus = payload;
    },
    resetSelectedStatu(state, payload) {
      state.selectedStatu = ["PLANLANDI", "BASLADI", "TEST EDILIYOR"];
    },
    resetSelectedAsamaStatu(state, payload) {
      state.selectedAsamaStatu = ["PLANLANDI", "BASLADI", "TEST EDILIYOR", ""];
    },
    setFilterAsamaList(state, payload) {
      // state.filteredAsamaList = payload;
      state.filteredAsamaList = payload.map((item, index) => ({
        ...item,
        SIRANO: index,
      }));
    },
    updateAsamaFilter(state, payload) {
      state.asamaEvrakNo = payload.EVRAKNO || "";
      state.asamaMusteriAdi = payload.MUSTERIKODU_AD || "";
      state.asamaProjeAdi = payload.PROJE_ADI || "";
      state.asamaTanimi = payload.ASAMA_TANIMI || "";
      state.asamaDurumu = payload.ASAMA_DURUMU || "";
      state.asamaAtananKisi = payload.ATANAN_KISI || "";
      state.asamaTahminSure = payload.TAHMINI_SURE;
      state.asamaAtamaTarihi =
        payload.ATAMA_TARIHI !== ""
          ? moment(payload.ATAMA_TARIHI).format("DD/MM/YYYY")
          : "";

      state.filteredAsamaList = state.asamaList.filter((asama) => {
        // Filtrelerin dizileri
        const filters = {
          EVRAKNO: state.asamaEvrakNo.map((item) => item.toLowerCase()),
          MUSTERIKODU_AD: state.asamaMusteriAdi.map((item) =>
            item.toLowerCase()
          ),
          PROJE_ADI: state.asamaProjeAdi.map((item) => item.toLowerCase()),
          ASAMA_DURUMU: state.asamaDurumu.map((item) => item.toLowerCase()),
          ATANAN_KISI: state.asamaAtananKisi.map((item) => item.toLowerCase()),
          TAHMINI_SURE: state.asamaTahminSure.map((item) => item.toLowerCase()),
          ATAMA_TARIH: state.asamaAtamaTarihi,
          ASAMA_TANIMI: (state.asamaTanimi || "").toLowerCase(),
        };

        // Filtrelerin her elemanıyla projeyi kontrol et
        return (
          (filters.EVRAKNO.length === 0 ||
            filters.EVRAKNO.some((filter) =>
              asama.EVRAKNO.toLowerCase().includes(filter)
            )) &&
          (filters.MUSTERIKODU_AD.length === 0 ||
            filters.MUSTERIKODU_AD.some((filter) =>
              asama.MUSTERIKODU_AD.toLowerCase().includes(filter)
            )) &&
          (filters.PROJE_ADI.length === 0 ||
            filters.PROJE_ADI.some((filter) =>
              asama.PROJE_ADI.toLowerCase().includes(filter)
            )) &&
          (filters.ASAMA_DURUMU.length === 0 ||
            filters.ASAMA_DURUMU.some((filter) =>
              asama.ASAMA_DURUMU.toLowerCase().includes(filter)
            )) &&
          (filters.ATANAN_KISI.length === 0 ||
            filters.ATANAN_KISI.some((filter) =>
              asama.ATANAN_KISI.toLowerCase().includes(filter)
            )) &&
          (filters.TAHMINI_SURE.length === 0 ||
            filters.TAHMINI_SURE.some((filter) =>
              asama.TAHMINI_SURE.toLowerCase().includes(filter)
            )) &&
          (filters.ATAMA_TARIH == "" ||
            filters.ATAMA_TARIH ==
              moment(asama.ATAMA_TARIHI).format("DD/MM/YYYY")) &&
          asama.ASAMA_TANIMI.toLowerCase().includes(filters.ASAMA_TANIMI)
        );
      });
    },
    setAsamaList(state, payload) {
      state.asamaList = payload;
      state.filteredAsamaList = payload;
    },
    setAsamaUser(state, payload) {
      state.asamaUser = payload;
    },
    setAdminStatuList(state, payload) {
      state.adminStatuList = payload;
    },
    setSelectedStatu(state, payload) {
      if (state.selectedStatu.includes(payload)) {
        if (state.selectedStatu.length !== 1) {
          state.selectedStatu = state.selectedStatu.filter(
            (statu) => statu !== payload
          );
        }
      } else {
        state.selectedStatu.push(payload);
      }
    },
    setSelectedAsamaStatu(state, payload) {
      if (state.selectedAsamaStatu.includes(payload)) {
        if (state.selectedAsamaStatu.length !== 1) {
          state.selectedAsamaStatu = state.selectedAsamaStatu.filter(
            (statu) => statu !== payload
          );
        }
      } else {
        state.selectedAsamaStatu.push(payload);
      }
    },
    setListType(state, payload) {
      state.listType = payload;
    },
    updateFilterProject(state, payload) {
      state.EVRAKNO = payload.EVRAKNO || "";
      state.MUSTERIKODU_AD = payload.MUSTERIKODU_AD || "";
      state.PROJE_ADI = payload.PROJE_ADI || "";
      state.PROJE_SORUMLUSU = payload.PROJE_SORUMLUSU || "";
      state.TALEP_EDEN_KISI = payload.TALEP_EDEN_KISI || "";
      state.TARIH =
        payload.TARIH !== "" ? moment(payload.TARIH).format("DD/MM/YYYY") : "";
      state.PROJE_ACIKLAMASI = payload.PROJE_ACIKLAMASI;
      state.PROJE_DURUMU = payload.PROJE_DURUMU;
    },
    setAllProject(state, payload) {
      state.allProject = payload;
    },
    setFileUrl(state, payload) {
      state.fileUrl.push({ path: payload.filePath, url: payload.url });
    },
    resetFileUrl(state) {
      state.fileUrl = [];
    },
    setDokumanlar(state, payload) {
      if (
        !Object.prototype.hasOwnProperty.call(state.dokumanlar, payload.EVRAKNO)
      ) {
        // Dinamik anahtar eklemek için
        state.dokumanlar = {
          ...state.dokumanlar,
          [payload.EVRAKNO]: [],
        };
      }
      state.dokumanlar[payload.EVRAKNO].push({
        TRNUM: payload.ID,
        FULLFILENAME: payload.DOKUMAN.filePath,
        OR_TRNUM: payload.TRNUM,
      });
    },
    setDokumanlarList(state, payload) {
      if (
        !Object.prototype.hasOwnProperty.call(state.dokumanlar, payload.EVRAKNO)
      ) {
        state.dokumanlar = {
          ...state.dokumanlar,
          [payload.EVRAKNO]: [],
        };
      }
      state.dokumanlar[payload.EVRAKNO] = payload.DOKUMAN;
    },
    resetProjectNameList(state, payload) {
      state.projectNameList = [];
    },
    setWorkList(state, payload) {
      state.workList = payload;
    },
    setProjectList(state, payload) {
      state.project = payload;
    },
    setCustomerList(state, payload) {
      state.customerList = payload;
    },
    setSystemList(state, payload) {
      state.systemList = payload;
    },
    setWorkType(state, payload) {
      payload.forEach((element) => {
        element.KOD = element.KOD.trim();
      });
      state.workType = payload;
    },
    resetProjectList(state) {
      state.projectList = [];
    },
    setErpUserList(state, payload) {
      state.erpUserList = payload;
    },
    setStatuList(state, payload) {
      state.statuList = payload;
    },
    setPlatformList(state, payload) {
      state.platformList = payload;
    },
    setRowPlatformList(state, payload) {
      state.rowPlatformList = payload;
    },
    setRowStageList(state, payload) {
      state.rowStageList = payload;
    },
    setProjectNameList(state, payload) {
      state.projectNameList = payload;
    },
    setProjectRow(state, payload) {
      state.projectRows = payload;
    },
    addProject(state, payload) {
      state.project.push(payload);
    },
    deleteDokumanlar(state, payload) {
      const index = state.dokumanlar[payload.EVRAKNO].findIndex((doc) => {
        return doc.FULLFILENAME == payload.filePath;
      });
      if (index !== -1) {
        state.dokumanlar[payload.EVRAKNO].splice(index, 1);
      }
    },
    deleteRow(state, payload) {
      state.projectRows = state.projectRows.filter(
        (item) => item.TRNUM !== payload
      );
    },
    setAsamaListDoc(state, payload) {
      const evrakNo = payload.EVRAKNO;
      if (
        !Object.prototype.hasOwnProperty.call(
          state.asamaListDoc,
          payload.EVRAKNO
        )
      ) {
        // Dinamik anahtar eklemek için
        state.asamaListDoc = {
          ...state.asamaListDoc,
          [payload.EVRAKNO]: [],
        };
      }
      payload.DOKUMAN.forEach((doc) => {
        state.asamaListDoc[payload.EVRAKNO].push({
          TRNUM: doc.id,
          FULLFILENAME: doc.reftexT04,
          OR_TRNUM: doc.reftexT03,
        });
      });

      // payload.DOKUMAN.forEach((doc) => {
      //   const trNum = doc.reftexT03;
      //   const filepath = doc.reftexT04;
      //   const id = doc.id;
      // });
    },
    resetAsamaListDoc(state) {
      state.asamaListDoc = [];
    },
  },
  getters: {
    getCalisilanSaat: (state) => state.calisilanSaat,
    getFaturalar: (state) => state.faturalar,
    getAsamaListDoc: (state) => state.asamaListDoc,
    getWorkAddStatus(state) {
      return state.workAddStatus;
    },
    getAsamaList: (state) => state.asamaList,
    getFilteredAsamaList(state) {
      return state.filteredAsamaList.map((item, index) => {
        {
          return {
            ...item,
            ASAMA_DURUMU: item.ASAMA_DURUMU.trim(),
          };
        }
      });
    },
    getAsamaUser: (state) => state.asamaUser,
    getSelectedStatu: (state) => state.selectedStatu,
    getSelectedAsamaStatu: (state) => state.selectedAsamaStatu,
    getAllProject(state) {
      return state.allProject;
    },
    getFilteredAllProject(state) {
      return state.allProject.filter((project) => {
        // Filtrelerin dizileri
        const filters = {
          EVRAKNO: state.EVRAKNO.map((item) => item.toLowerCase()),
          MUSTERIKODU_AD: state.MUSTERIKODU_AD.map((item) =>
            item.toLowerCase()
          ),
          PROJE_ADI: state.PROJE_ADI.map((item) => item.toLowerCase()),
          PROJE_SORUMLUSU: state.PROJE_SORUMLUSU.map((item) =>
            item.toLowerCase()
          ),
          PROJE_DURUMU: state.PROJE_DURUMU.map((item) => item.toLowerCase()),
          TALEP_EDEN_KISI: state.TALEP_EDEN_KISI.map((item) =>
            item.toLowerCase()
          ),
          TARIH: state.TARIH,
          PROJE_ACIKLAMASI: (state.PROJE_ACIKLAMASI || "").toLowerCase(),
        };

        // Filtrelerin her elemanıyla projeyi kontrol et
        return (
          (filters.EVRAKNO.length === 0 ||
            filters.EVRAKNO.some((filter) =>
              project.EVRAKNO.toLowerCase().includes(filter)
            )) &&
          (filters.MUSTERIKODU_AD.length === 0 ||
            filters.MUSTERIKODU_AD.some((filter) =>
              project.MUSTERIKODU_AD.toLowerCase().includes(filter)
            )) &&
          (filters.PROJE_ADI.length === 0 ||
            filters.PROJE_ADI.some((filter) =>
              project.PROJE_ADI.toLowerCase().includes(filter)
            )) &&
          (filters.PROJE_SORUMLUSU.length === 0 ||
            filters.PROJE_SORUMLUSU.some((filter) =>
              project.PROJE_SORUMLUSU.toLowerCase().includes(filter)
            )) &&
          (filters.PROJE_DURUMU.length === 0 ||
            filters.PROJE_DURUMU.some((filter) =>
              project.PROJE_DURUMU.toLowerCase().includes(filter)
            )) &&
          (filters.TALEP_EDEN_KISI.length === 0 ||
            filters.TALEP_EDEN_KISI.some((filter) =>
              project.TALEP_EDEN_KISI.toLowerCase().includes(filter)
            )) &&
          (filters.TARIH == "" ||
            filters.TARIH.trim() ==
              moment(project.TARIH).format("DD/MM/YYYY")) &&
          project.PROJE_ACIKLAMASI.toLowerCase().includes(
            filters.PROJE_ACIKLAMASI
          )
        );
      });
    },
    getDokumanlar: (state) => state.dokumanlar,
    getFileUrlList: (state) => state.fileUrl,
    getWorkList(state) {
      return state.workList.map((work) => {
        const MASRAF_SAAT = work.MASRAF_SAAT.replace(",", "."); // Değişiklik burada yapılıyor
        const SumWorkTime =
          work.REVIZE_SAAT > 0 ? work.REVIZE_SAAT : work.PERSONEL_SAAT;
        const CalcWorkTime =
          MASRAF_SAAT > 0
            ? Number(MASRAF_SAAT) + Number(SumWorkTime)
            : Number(SumWorkTime);

        return {
          ...work, // Orijinal work nesnesini değiştirmek yerine kopyasını döndür
          MASRAF_SAAT,
          SumWorkTime,
          CalcWorkTime,
        };
      });
    },
    getProject(state) {
      return state.project.filter((project) => {
        return project.PROJE_ADI_ASAMA_TANIMI !== null;
      });
    },
    getCustomerList: (state) => state.customerList,
    getSystemList: (state) => state.systemList,
    getWorkType: (state) => state.workType,
    getErpUserList: (state) => state.erpUserList,
    getStatuList: (state) => state.statuList,
    getPlatformList: (state) => state.platformList,
    getRowPlatformList: (state) => state.rowPlatformList,
    getRowStageList: (state) => state.rowStageList,
    getProjectNameList: (state) => state.projectNameList,
    getProjectRow: (state) => state.projectRows,
    getFilteredAsamaRow(state) {
      return state.projectRows.filter((item) =>
        state.selectedAsamaStatu.includes(item.ASAMA_DURUMU.trim())
      );
    },
    getListType: (state) => state.listType,
    getAdminStatuList: (state) => state.adminStatuList,
  },
  actions: {
    async fetchWorkList({ state, commit }) {
      let kriterler = {
        queryKey: "D7kIsListesiGetir",
        metin1: state.listType,
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit("setWorkList", JSON.parse(response.data.data.dataJson));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async searchProject({ commit }, payload) {
      let kriterler = {
        queryKey: "D7kProjeleriGetir",
        metin1: payload.searchCode,
        metin2: payload.customerCode || " ",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit("setProjectList", JSON.parse(response.data.data.dataJson));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async fetchWorkListCustomerList({ commit }) {
      let kriterler = {
        queryKey: "OzelIsListesiMusteriGetir",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit("setCustomerList", JSON.parse(response.data.data.dataJson));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async editWork({ dispatch }, payload) {
      const jsonValue = {
        ACIKLAMA: payload.ACIKLAMA,
        ASAMA_TANIMI: payload.ASAMA_TANIMI,
        BASSAAT: payload.BASSAAT,
        BASTARIH: payload.BASTARIH,
        BITSAAT: payload.BITSAAT,
        BITTARIH: payload.BITTARIH,
        CALISMA_TIPI: payload.CALISMA_TIPI,
        CH_ADI: payload.CH_ADI,
        CH_KODU: payload.CH_KODU,
        EVRAKNO: payload.EVRAKNO,
        MASRAF_SAAT: payload.MASRAF_SAAT,
        ODEMESI_YAPILDIMI: payload.ODEMESI_YAPILDIMI,
        OLUSTURAN: payload.OLUSTURAN,
        PERSONEL_SAAT: payload.PERSONEL_SAAT,
        PROJE: payload.PROJE,
        PROJE_ADI: payload.PROJE_ADI,
        REVIZE_SAAT: payload.REVIZE_SAAT,
        SAAT: payload.SAAT,
        SISTEM: payload.SISTEM,
        STATU: payload.STATU,
        TARIH: payload.TARIH,
        TARIH_SAAT: payload.TARIH_SAAT,
        UCRET: payload.UCRET,
        ISTYPE: payload.ISTYPE,
      };
      var jsonconvert = JSON.stringify(jsonValue);
      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: jsonconvert,
        MacroKey: "IsListesiKaydet",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("Com/RunMacroWithAuth", request)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  dispatch("fetchWorkList");
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  resolve(success);
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch (e) {
          let error = {
            color: "danger",
            title: "Web Hatası",
            text: "Web tarafın bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
            acceptText: "Kapat",
            accept: null,
          };
          reject(error);

          // commit("setErrorStatus", error);
        }
      });
    },
    async normalEditWork({ dispatch }, payload) {
      const jsonValue = {
        SISTEM: payload.SISTEM,
        CH_KODU: payload.CH_KODU,
        ISTYPE: payload.ISTYPE,
        PROJE: payload.PROJE,
        ACIKLAMA: payload.ACIKLAMA,
        CALISMA_TIPI: payload.CALISMA_TIPI,
        PERSONEL_SAAT: payload.PERSONEL_SAAT,
        BASTARIH: payload.BASTARIH,
        EVRAKNO: payload.EVRAKNO,
      };
      var jsonconvert = JSON.stringify(jsonValue);
      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: jsonconvert,
        MacroKey: "IsListesiKaydetPersonel",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("Com/RunMacroWithAuth", request)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  dispatch("fetchWorkList");
                  resolve(success);
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch (e) {
          let error = {
            color: "danger",
            title: "Web Hatası",
            text: "Web tarafın bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
            acceptText: "Kapat",
            accept: null,
          };
          reject(error);

          // commit("setErrorStatus", error);
        }
      });
    },
    async saveWork({ rootState }, payload) {
      const jsonValue = {
        EVRAKNO: "",
        CH_KODU: payload.customer.KOD,
        SISTEM: payload.system.KOD,
        PROJE: payload.project ? payload.project.ARTNO : "",
        ACIKLAMA: payload.description,
        OLUSTURAN:
          payload.user == ""
            ? rootState.signalRStore.myUser.erpUserName
            : payload.user,
        CALISMA_TIPI: payload.workType,
        PERSONEL_SAAT: payload.workHour,
        BASTARIH: payload.date.toString(),
        REVIZE_SAAT: "",
        MASRAF_SAAT: "",
        ISTYPE: payload.isHelp,
        ASAMA_DURUMU: payload.asama_durum,
      };
      var jsonconvert = JSON.stringify(jsonValue);
      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: jsonconvert,
        MacroKey: "IsListesiKaydet",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("Com/RunMacroWithAuth", request)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  resolve(success);
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch (e) {
          let error = {
            color: "danger",
            title: "Web Hatası",
            text: "Web tarafın bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
            acceptText: "Kapat",
            accept: null,
          };
          reject(error);

          // commit("setErrorStatus", error);
        }
      });
    },
    async adminStatuUpload({}, payload) {
      const sqlFriendlyString = payload.evrakList
        .map((status) => `'${status}'`)
        .join(",");
      let kriterler = {
        queryKey: "D7KisListesi_STATU_Update",
        metin1: sqlFriendlyString,
        metin2: payload.statu,
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("v1/Dynamic/GetQueryReplaceData", kriterler)
            .then(async (response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let kriterler = {
                    queryKey: "D7kIsListesiGetir",
                    metin1: "",
                  };
                  await fetchAx
                    .post("v1/Dynamic/GetQueryReplaceData", kriterler)
                    .then((response) => {
                      let success = {
                        color: "success",
                        text: "İşlem Başarılı...",
                        position: "bottom-center",
                      };
                      resolve({
                        success: success,
                        data: JSON.parse(response.data.data.dataJson),
                      });
                    })
                    .catch((error) => {
                      console.error("Error fetching data:", error);
                    });
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch (e) {
          // reject(e);

          reject();
        }
      });
    },
    async fetchSystemList({ commit }) {
      const kriterler = {
        metin1: "GECOUST",
        metin2: "!ISL000001",
        queryKey: "DinamikGrupDataGetir",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit("setSystemList", JSON.parse(response.data.data.dataJson));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async fetchAdminStatuList({ commit }) {
      const kriterler = {
        metin1: "GECOUST",
        metin2: "!ISL000003",
        queryKey: "DinamikGrupDataGetir",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit("setAdminStatuList", JSON.parse(response.data.data.dataJson));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async fetchWorkType({ commit }) {
      const kriterler = {
        metin1: "GECOUST",
        metin2: "!ISL000002",
        queryKey: "DinamikGrupDataGetir",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit("setWorkType", JSON.parse(response.data.data.dataJson));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async saveProject({ commit }, payload) {
      const data = {
        EVRAKNO: payload.EVRAKNO || "",
        PROJE_ADI: payload.name,
        PLATFORM: payload.platform,
        ONCELIK: Number(payload.priority),
        PROJE_DURUMU: payload.statu,
        PROJE_ACIKLAMASI: payload.description,
        MUSTERIKODU: payload.customer.KOD,
        MUSTERIKODU_AD: payload.customer.AD,
        TALEP_EDEN_KISI: payload.requester,
        BASTARIH: payload.startDate,
        BITTARIH: payload.endDate,
        PROJE_TERMIN: payload.deadLine,
        TAMAMLANMA_TARIHI: "",
        ONGORULEN_PROJE_SURESI_SAAT: payload.priority,
        PROJE_SORUMLUSU: payload.responsible,
        SATIRLAR: [],
      };
      var jsonconvert = JSON.stringify(data);
      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: jsonconvert,
        MacroKey: "D7KProjeKaydet",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("Com/RunMacroWithAuth", request)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  resolve(success);
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch (e) {
          let error = {
            color: "danger",
            title: "Web Hatası",
            text: "Web tarafın bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
            acceptText: "Kapat",
            accept: null,
          };
          reject(error);

          // commit("setErrorStatus", error);
        }
      });
    },
    async saveProjectWithRows({}, payload) {
      const data = {
        EVRAKNO: payload.proje[0].EVRAKNO,
        PROJE_ADI: payload.proje[0].PROJE_ADI,
        PLATFORM: payload.proje[0].PLATFORM,
        ONCELIK: Number(payload.proje[0].ONCELIK),
        PROJE_DURUMU: payload.proje[0].PROJE_DURUMU,
        PROJE_ACIKLAMASI: payload.proje[0].PROJE_ACIKLAMASI,
        MUSTERIKODU: payload.proje[0].MUSTERIKODU,
        MUSTERIKODU_AD: payload.proje[0].MUSTERIKODU_AD,
        TALEP_EDEN_KISI: payload.proje[0].TALEP_EDEN_KISI,
        BASTARIH: payload.proje[0].BASTARIH,
        BITTARIH: payload.proje[0].BITTARIH,
        PROJE_TERMIN: payload.proje[0].PROJE_TERMIN,
        TAMAMLANMA_TARIHI: payload.proje[0].TAMAMLANMA_TARIHI,
        ONGORULEN_PROJE_SURESI_SAAT:
          payload.proje[0].ONGORULEN_PROJE_SURESI_SAAT,
        PROJE_SORUMLUSU: payload.proje[0].PROJE_SORUMLUSU,
        SATIRLAR: payload.satirlar,
      };
      var jsonconvert = JSON.stringify(data);
      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: jsonconvert,
        MacroKey: "D7KProjeKaydet",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("Com/RunMacroWithAuth", request)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };

                  resolve(success);
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch (e) {
          let error = {
            color: "danger",
            title: "Web Hatası",
            text: "Web tarafın bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
            acceptText: "Kapat",
            accept: null,
          };
          reject(error);

          // commit("setErrorStatus", error);
        }
      });
    },
    async fetchErpUser({ commit }) {
      let kriterler = {
        queryKey: "ErpUserGetir",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit("setErpUserList", JSON.parse(response.data.data.dataJson));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async fetchStatuList({ commit }) {
      const kriterler = {
        metin1: "GECOUST",
        metin2: "!ZU_PRJ002",
        queryKey: "DinamikGrupDataGetir",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit("setStatuList", JSON.parse(response.data.data.dataJson));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async fetchPlatformList({ commit }) {
      const kriterler = {
        metin1: "GECOUST",
        metin2: "!ZU_PRJ001",
        queryKey: "DinamikGrupDataGetir",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit("setPlatformList", JSON.parse(response.data.data.dataJson));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async fetchRowPlatformList({ commit }) {
      const kriterler = {
        metin1: "GECOUST",
        metin2: "!ZU_PRJ005",
        queryKey: "DinamikGrupDataGetir",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit("setRowPlatformList", JSON.parse(response.data.data.dataJson));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async fetchRowStageList({ commit }) {
      const kriterler = {
        metin1: "GECOUST",
        metin2: "!ZU_PRJ002",
        queryKey: "DinamikGrupDataGetir",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit("setRowStageList", JSON.parse(response.data.data.dataJson));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async searchProjectName({ commit }, payload) {
      let kriterler = {
        queryKey: "D7kProjeleriGetirProjeAdi",
        metin1: payload,
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit("setProjectNameList", JSON.parse(response.data.data.dataJson));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async fetchRows({ commit }, payload) {
      let kriterler = {
        queryKey: "D7kProjeleriGetirProjeSatirlari",
        metin1: payload,
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("v1/Dynamic/GetQueryReplaceData", kriterler)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                } else {
                  commit(
                    "setProjectRow",
                    JSON.parse(response.data.data.dataJson)
                  );
                  resolve(JSON.parse(response.data.data.dataJson));
                }
              } else {
              }
            });
        } catch (e) {
          reject(error);
        }
      });
    },
    async fetchProjectEvrak({}, payload) {
      let kriterler = {
        queryKey: "D7kProjeleriGetirProjeEvrak",
        metin1: payload,
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("v1/Dynamic/GetQueryReplaceData", kriterler)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                } else {
                  resolve(JSON.parse(response.data.data.dataJson));
                }
              } else {
              }
            });
        } catch (e) {
          reject(e);
        }
      });
    },
    async addDokumanProject({ state }, payload) {
      // // const jsonValue = {
      // //   EVRAKNO: payload.EVRAKNO,
      // //   dokumanlar: state.dokumanlar[payload.EVRAKNO],
      // // };
      // // var jsonconvert = JSON.stringify(jsonValue);
      // // let request = {
      // //   FunctionName: "d7kRun",
      // //   MacroName: "D7KSUP007",
      // //   JsonParams: jsonconvert,
      // //   MacroKey: "D7KProjeDokumanKaydet",
      // // };
      // // return new Promise(async (resolve, reject) => {
      // //   try {
      // //     await fetchAx
      // //       .post("Com/RunMacroWithAuth", request)
      // //       .then((response) => {
      // //         if (response.status == 200) {
      // //           if (response.data.succeeded == false) {
      // //             let error = {
      // //               color: "danger",
      // //               title: "Api Hatası",
      // //               text: response.data.message,
      // //               position: "top-center",
      // //             };
      // //             reject(error);
      // //           } else {
      // //             let success = {
      // //               color: "success",
      // //               text: "İşlem Başarılı...",
      // //               position: "bottom-center",
      // //             };
      // //             resolve(success);
      // //           }
      // //         } else {
      // //           let error = {
      // //             color: "danger",
      // //             title: "Api Hatası",
      // //             text: response.data.message,
      // //             position: "top-center",
      // //           };
      // //           reject(error);
      // //         }
      // //       });
      // //   } catch (e) {
      // //     let error = {
      // //       color: "danger",
      // //       title: "Web Hatası",
      // //       text: "Web tarafın bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
      // //       acceptText: "Kapat",
      // //       accept: null,
      // //     };
      // //     reject(error);

      // //     // commit("setErrorStatus", error);
      // //   }
      // // });

      return new Promise(async (resolve, reject) => {
        try {
          let newRecordRequest = {
            REFTEXT01: "isListesiDokuman",
            REFTEXT02: payload.EVRAKNO,
            REFTEXT03: payload.TRNUM,
            REFTEXT04: payload.DOKUMAN.filePath,
            REFTEXT05: "",
            REFTEXT06: "",
            REFTEXT07: "",
            REFTEXT08: "",
            REFTEXT09: "",
            REFTEXT10: "",
          };

          fetchAx
            .post("GenelAmacli/Create", newRecordRequest)
            .then((response) => {
              resolve(response);
            })
            .catch((e) => {
              let error = {
                title: "Hata",
                text: e.response.data,
                color: "danger",
                position: "top-center",
              };
              reject(error);
            });
        } catch (e) {
          console.log("e :>> ", e);
        }
      });
    },
    async fetchDokumanProject({ commit, dispatch, state }, payload) {
      let params = new URLSearchParams();
      params.append("ref01", "isListesiDokuman");
      params.append("ref02", payload);
      try {
        var response = await fetchAx.get(
          `GenelAmacli/GetByRef02?${params.toString()}`
        );
        const transformed = response.data.map((item) => ({
          FULLFILENAME: item.reftexT04,
          OR_TRNUM: item.reftexT03,
          TRNUM: item.id,
        }));
        commit("setDokumanlarList", {
          EVRAKNO: payload,
          DOKUMAN: transformed,
        });
      } catch (error) {}
    },
    async deleteAllDoc({ state }, payload) {},
    async deleteApiDoc({ dispatch, state }, payload) {
      state.dokumanlar[payload.EVRAKNO].forEach(async (element) => {
        if (element.OR_TRNUM == payload.TRNUM) {
          await dispatch("fileUploadStore/deleteFile", element.FULLFILENAME, {
            root: true,
          });
        }
      });
    },
    async deleteSelectedDoc({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        const params = new URLSearchParams();

        if (payload.ID) params.append("id", payload.ID);
        fetchAx
          .delete(`GenelAmacli/Delete?${params.toString()}`)
          .then((response) => {
            let success = {
              title: "Başarılı",
              text: "İşlem Tipi silindi.",
              color: "success",
              position: "top-center",
            };
            resolve(success);
          })
          .catch((error) => {
            let e = {
              title: "Hata",
              text: error,
              color: "danger",
              position: "top-center",
            };
            reject(e);
          });
      });
    },
    async fetchAllProjectList({ state, commit }) {
      const sqlFriendlyString = state.selectedStatu
        .map((status) => `'${status}'`)
        .join(",");
      let kriterler = {
        queryKey: "D7kProjeListele",
        metin1: sqlFriendlyString,
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit("setAllProject", JSON.parse(response.data.data.dataJson));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async updateFatura({}, payload) {
      let jsonValue = {
        satirlar: payload,
      };
      var jsonconvert = JSON.stringify(jsonValue);
      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: jsonconvert,
        MacroKey: "IsListesiFaturaKaydet",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("Com/RunMacroWithAuth", request)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  resolve(success);
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch (e) {
          let error = {
            color: "danger",
            title: "Web Hatası",
            text: "Web tarafın bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
            acceptText: "Kapat",
            accept: null,
          };
          reject(error);

          // commit("setErrorStatus", error);
        }
      });
    },
    async updateOnay({}, payload) {
      const sqlFriendlyString = payload
        .map((status) => `'${status}'`)
        .join(",");
      let kriterler = {
        queryKey: "D7KisListesi_YANSITILACAKMI_Update",
        metin1: sqlFriendlyString,
        metin2: "1",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("v1/Dynamic/GetQueryReplaceData", kriterler)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  resolve(success);
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch (e) {
          // reject(e);
          clo(e);
          reject();
        }
      });
    },
    async updateOdeme({}, payload) {
      const sqlFriendlyString = payload
        .map((status) => `'${status}'`)
        .join(",");
      let kriterler = {
        queryKey: "D7KisListesi_ODEMESI_YAPILDIMI_Update",
        metin1: sqlFriendlyString,
        metin2: "1",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("v1/Dynamic/GetQueryReplaceData", kriterler)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  resolve(success);
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch (e) {
          // reject(e);
          clo(e);
          reject();
        }
      });
    },
    async fetchDiscordId({ commit }, payload) {
      let kriterler = {
        queryKey: "D7KisListesi_Discord_Id_Getir",
        metin1: payload,
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          commit(
            "setDiscordId",
            JSON.parse(response.data.data.dataJson)[0].DISCORD_ID
          );
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async fetchAllAsamaList({ state, commit, dispatch }, payload) {
      const sqlFriendlyString = state.selectedStatu
        .map((status) => `'${status}'`)
        .join(",");
      let kriterler = {
        queryKey: "D7kAsamalariGetir",
        metin1: state.asamaUser,
        metin2: sqlFriendlyString,
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          // commit("setAllProject", JSON.parse(response.data.data.dataJson));
          commit("setAsamaList", JSON.parse(response.data.data.dataJson));
          commit("resetAsamaListDoc");
          dispatch("fetchAsamaListDoc");
          dispatch("fetchFilterAsamaList", state.filteredAsamaList);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async fetchAsamaListDoc({ state, commit }) {
      const evrakNoList = [
        ...new Set(state.asamaList.map((item) => item.EVRAKNO)),
      ];
      evrakNoList.forEach((evrakNo) => {
        fetchAx
          .get(`GenelAmacli/GetByRef02?ref01=isListesiDokuman&ref02=${evrakNo}`)
          .then((response) => {
            if (response.data.length > 0) {
              commit("setAsamaListDoc", {
                EVRAKNO: evrakNo,
                DOKUMAN: response.data,
              });
            }
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      });
    },
    async fetchFilterAsamaList({ state, commit }, payload) {
      commit("setFilterAsamaList", payload);
      let jsonValue = {
        satirlar: state.filteredAsamaList.map((asama) => {
          return {
            EVRAKNO: asama.EVRAKNO,
            TRNUM: asama.TRNUM,
            SIRANO: asama.SIRANO,
          };
        }),
      };

      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: JSON.stringify(jsonValue),
        MacroKey: "ProjeAsamaSiraNoUpdate",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("Com/RunMacroWithAuth", request)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  resolve(success);
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch (e) {
          let error = {
            color: "danger",
            title: "Web Hatası",
            text: "Web tarafın bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
            acceptText: "Kapat",
            accept: null,
          };
          reject(error);

          // commit("setErrorStatus", error);
        }
      });
    },
    async deleteWork({}, payload) {
      var kriterler2 = {
        ModulName: "ZU_ISL",
        DocNo: payload,
      };

      var request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: JSON.stringify(kriterler2),
        MacroKey: "EvrakSil",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("Com/RunMacroWithAuth", request)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  resolve(success);
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch (e) {
          let error = {
            color: "danger",
            title: "Web Hatası",
            text: "Web tarafın bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
            acceptText: "Kapat",
            accept: null,
          };
          reject(error);

          // commit("setErrorStatus", error);
        }
      });
    },
    async setWorkStatus({ dispatch, commit }, payload) {
      commit("setWorkAddStatus", payload);
      let deger = 1;
      payload ? (deger = 0) : "";
      let kriterler = {
        queryKey: "IsListesiKullanimaAcKapa",
        metin1: "!ISLIST01",
        metin2: String(deger),
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          dispatch("fethWorkStatus");
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async fethWorkStatus({ commit }) {
      let kriterler = {
        queryKey: "IsListesiKullanimDurumu",
        metin1: "!ISLIST01",
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          let deger = false;
          JSON.parse(response.data.data.dataJson)[0].DURUM == 0
            ? (deger = true)
            : "";
          commit("setWorkAddStatus", deger);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    async asamaUpdateList({ dispatch }, payload) {
      let kriterler = {
        queryKey: "ProjeAsamaDurumUpdate",
        metin1: payload.asama.EVRAKNO,
        metin2: payload.asama.TRNUM,
        metin3: payload.durum,
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("v1/Dynamic/GetQueryReplaceData", kriterler)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                } else {
                  dispatch("fetchAllAsamaList");
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  resolve(success);
                }
              } else {
              }
            });
        } catch (e) {
          reject(error);
        }
      });
    },
    async fetchAllFatura({ commit }) {
      let kriterler = {
        queryKey: "D7K_IsListesi_Olusturulmus_Faturalar",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("v1/Dynamic/GetQueryReplaceData", kriterler)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                } else {
                  commit(
                    "setFaturalar",
                    JSON.parse(response.data.data.dataJson)
                  );
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  resolve(success);
                }
              } else {
              }
            });
        } catch (e) {
          reject(error);
        }
      });
    },
    async addFatura({}, payload) {
      let jsonValue = {
        evrakno: payload.evrakNo,
        satirlar: payload.satirlar,
      };
      var jsonconvert = JSON.stringify(jsonValue);
      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: jsonconvert,
        MacroKey: "IsListesiFaturaKaydet",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("Com/RunMacroWithAuth", request)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  resolve(success);
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch (e) {
          let error = {
            color: "danger",
            title: "Web Hatası",
            text: "Web tarafın bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
            acceptText: "Kapat",
            accept: null,
          };
          reject(error);

          // commit("setErrorStatus", error);
        }
      });
    },
    async sendMail({}, payload) {
      let jsonValue = {
        EVRAKNO: payload.evrakNo,
        kontrol: payload.kontrol,
      };
      var jsonconvert = JSON.stringify(jsonValue);
      let request = {
        FunctionName: "d7kRun",
        MacroName: "D7KSUP007",
        JsonParams: jsonconvert,
        MacroKey: "IsListesiFaturaMail",
      };
      return new Promise(async (resolve, reject) => {
        try {
          await fetchAx
            .post("Com/RunMacroWithAuth", request)
            .then((response) => {
              if (response.status == 200) {
                if (response.data.succeeded == false) {
                  let error = {
                    color: "danger",
                    title: "Api Hatası",
                    text: response.data.message,
                    position: "top-center",
                  };
                  reject(error);
                } else {
                  let success = {
                    color: "success",
                    text: "İşlem Başarılı...",
                    position: "bottom-center",
                  };
                  resolve(success);
                }
              } else {
                let error = {
                  color: "danger",
                  title: "Api Hatası",
                  text: response.data.message,
                  position: "top-center",
                };
                reject(error);
              }
            });
        } catch (e) {
          let error = {
            color: "danger",
            title: "Web Hatası",
            text: "Web tarafın bir sorun oluştu sistem yöneticiniz ile görüşünüz.!",
            acceptText: "Kapat",
            accept: null,
          };
          reject(error);
        }
      });
    },
    async fetchDiscord({ state, dispatch }, payload) {
      return new Promise(async (resolve, reject) => {
        const url = `filter?GetActivities=${payload.GetActivities}&StartDate=${payload.StartDate}&EndDate=${payload.EndDate}&UserId=${state.discordId}`;
        dispatch("fetchWorkHour", { tarih: payload.tarih });
        discAx
          .get(url)
          .then((response) => resolve(response.data))
          .catch((error) => {
            console.error("Error fetching Discord data:", error);
            reject(error);
          });
      });
    },
    async fetchWorkHour({ state, commit }, payload) {
      let kriterler = {
        queryKey: "ZU_ISL10T_GirilenCalismaSaatiGetir",
        metin1: payload.tarih,
      };
      await fetchAx
        .post("v1/Dynamic/GetQueryReplaceData", kriterler)
        .then((response) => {
          if (JSON.parse(response.data.data.dataJson)[0].SAAT !== null) {
            commit(
              "setCalisilanSaat",
              JSON.parse(response.data.data.dataJson)[0].SAAT
            );
          }
          if (response.status == 200) {
            if (response.data.succeeded == false) {
            } else {
            }
          } else {
          }
        });
    },
  },
};
